import React, { Component } from "react";
import debounce from "lodash.debounce";
import { connect } from "react-redux";
import _ from "i18n";
import {
  initFilterClient,
  setFilterClientGroup,
  setDynamicTableSearchWord,
  setDynamicTableSortBy,
  setClientType,
  setClientCRMType,
  setClientCRMGroup,
  setClientsDeletedState,
  setDynamicTableCollaboratorRole,
  setDynamicTableCollaboratorAttribution
} from "Actions";
import { fetchCollaboratorFinancial } from "Thunks";
import TTPFilterHorizontalBar from "../Common/filters/TTPFilterHorizontalBar";
import {
  FINANCIAL_COLLABORATOR_SORT_TYPES,
  CLIENT_GROUP_CRM_FILTER,
  CLIENT_CRM_TYPE_FILTER,
  COLLABORATOR_ATTRIBUTION_FILTER,
  COLLABORATOR_ROLE_ATTRIBUT,
  DELETED_STATUS
} from "Config";

class CapacityPlaningCollaboratorFilter extends Component {
  constructor(props) {
    super(props);
    //to add sort by revenu "to change FINANCIAL_COLLABORATOR_SORT_TYPES to DYNAMIC_TABLE_SORT_TYPES"
    this.sortOptions = Object.keys(FINANCIAL_COLLABORATOR_SORT_TYPES).map(
      roleType => {
        return {
          label: _(roleType),
          options: FINANCIAL_COLLABORATOR_SORT_TYPES[roleType].map(
            ({ value, label }) => {
              return { label: _(label), value: value };
            }
          )
        };
      }
    );
    this.handleSearchInputChange = debounce(this.handleSearchInputChange, 1000);
  }

  componentDidUpdate(prevProps, prevState) {
    const { budgetState, dispatch, analyseDate } = this.props;
    if (prevProps.budgetState !== budgetState) {
      dispatch(fetchCollaboratorFinancial(analyseDate));
    }
  }

  filterFormIsVisible = isVisible => {
    this.props.filterFormIsVisible(isVisible);
  };

  handleResetFilter = () => {
    // TODO
  };

  handleRefreshDynamicTable = () => {
    const { dispatch, analyseDate } = this.props;
    dispatch(fetchCollaboratorFinancial(analyseDate));
  };

  handleSetDeletedStatus = selectedStatus => {
    this.props.dispatch(setClientsDeletedState(selectedStatus));
    this.handleRefreshDynamicTable();
  };

  handleClientGroupChange = selected => {
    this.props.dispatch(setFilterClientGroup(selected));
    this.props.dispatch(initFilterClient());
    this.handleRefreshDynamicTable();
  };

  handleSortChange = selected => {
    this.setState(() => {
      this.props.dispatch(setDynamicTableSortBy(selected));
      this.handleRefreshDynamicTable();
    });
  };

  handleSearchInputChange(word) {
    this.props.dispatch(setDynamicTableSearchWord(word));
    this.handleRefreshDynamicTable();
  }

  handleTypeClientChange = selected => {
    this.props.dispatch(setClientType(selected));
    this.handleRefreshDynamicTable();
  };

  handleGroupCRMClientChange = selected => {
    this.props.dispatch(setClientCRMGroup(selected));
    this.handleRefreshDynamicTable();
  };

  handleTypeCRMClientChange = selected => {
    this.props.dispatch(setClientCRMType(selected));
    this.handleRefreshDynamicTable();
  };

  handleCollaboratorRoleChange = selected => {
    this.props.dispatch(setDynamicTableCollaboratorRole(selected));
    this.handleRefreshDynamicTable();
  };

  handleCollaboratorAttributionChange = selected => {
    this.props.dispatch(setDynamicTableCollaboratorRole(""));
    this.props.dispatch(setDynamicTableCollaboratorAttribution(selected));
    this.handleRefreshDynamicTable();
  };

  handleListPageSizeChange = selected => {
    this.props.handleDynamicTablePageSize(selected);
  };

  render() {
    let {
      financialSheetFilter,
      customAddOn,
      filter,
      pageSize,
      resultCount
    } = this.props;

    let filters = [
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          placeholder: _("sortBy"),
          options: this.sortOptions,
          action: this.handleSortChange,
          values: financialSheetFilter.sortBy.selected
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: false,
          isMulti: true,
          isClearable: true,
          placeholder: _("Type Client (CRM)"),
          options: CLIENT_CRM_TYPE_FILTER,
          values: filter.clientCRMTypes,
          action: this.handleTypeCRMClientChange
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          isClearable: true,
          placeholder: _("clientState"),
          options: DELETED_STATUS,
          values: filter.deletedStatus,
          action: this.handleSetDeletedStatus
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          placeholder: _("Dossiers où il"),
          options: COLLABORATOR_ATTRIBUTION_FILTER,
          values: filter.collaboratorAttribution,
          action: this.handleCollaboratorAttributionChange
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: false,
          isMulti: true,
          isClearable: true,
          placeholder: _("Groupe Client (CRM)"),
          options: CLIENT_GROUP_CRM_FILTER,
          values: filter.clientCRMGroup,
          action: this.handleGroupCRMClientChange
        }
      }
    ];
    filter.collaboratorAttribution === "BUDGETED_FOLDERS" &&
      filters.push({
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          placeholder: _("Collaborateur Role"),
          options: COLLABORATOR_ROLE_ATTRIBUT,
          values: filter.collaboratorRole,
          action: this.handleCollaboratorRoleChange
        }
      });
    return (
      <div className="row align-center medium-12">
        <div className="medium-12">
          <TTPFilterHorizontalBar
            button
            filters={filters}
            customAddOn={customAddOn}
            handleResetFilter={this.handleResetFilter}
            searchPlaceholder="Search by client name"
            searchInputValue={financialSheetFilter.searchWord.searchWord}
            handleSearchInputChange={this.handleSearchInputChange.bind(this)}
            filterFormIsVisible={this.filterFormIsVisible}
            pageSize={pageSize}
            label={_("folderNumber")}
            nbResult={resultCount}
            marginLeft={"12.5em"}
            handleListPageSizeChange={this.handleListPageSizeChange}
            cssClass="medium-12"
          />
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  financialSheetFilter: state.financialSheet.periodFilter,
  currentOrganization: state.auth.currentOrganization,
  budgetState: state.budget.dynamicTable.filter.budgetState,
  filter: state.financialSheet.periodTree.filter
});

export default connect(mapStateToProps)(CapacityPlaningCollaboratorFilter);



// WEBPACK FOOTER //
// ./src/components/CapacityPlanning/CapacityPlanningCollaboratorFilter.js